import { put, takeLatest, fork, call } from "redux-saga/effects";
import {
  IConsultationCSVResponse,
  ActionType,
  DownloadConsultationCSVPayload,
} from "models/consultations/downloadConsultationCSV";
import { httpStatus } from "configs/httpStatus";
import { downloadConsultationCSV } from "services/consultations";
import {
  handleSuccessAction,
  handleErrorAction,
} from "./downloadConsultationCSVActions";

function* downloadConsultationCSVSaga({
  payload,
}: {
  payload: DownloadConsultationCSVPayload;
}) {
  try {
    const response: IConsultationCSVResponse = yield call(
      downloadConsultationCSV,
      payload
    );
    if (response.status === httpStatus.StatusOK) {
      yield put(handleSuccessAction(response));
    } else {
      yield put(handleErrorAction(response.message || ""));
    }
  } catch (error) {
    yield put(handleErrorAction("error"));
  }
}
function* onDownloadConsultationCSVWatcher() {
  yield takeLatest(
    ActionType.DOWNLOAD_CONSULTATION_CSV as any,
    downloadConsultationCSVSaga
  );
}

export default [fork(onDownloadConsultationCSVWatcher)];
